import { render } from "./PrintInvoiceWordsDesign3.vue?vue&type=template&id=57b476bc&scoped=true"
import script from "./PrintInvoiceWordsDesign3.vue?vue&type=script&lang=js"
export * from "./PrintInvoiceWordsDesign3.vue?vue&type=script&lang=js"

import "./PrintInvoiceWordsDesign3.vue?vue&type=style&index=0&id=57b476bc&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57b476bc"]])

export default __exports__